import { render, staticRenderFns } from "./RoomBasement.vue?vue&type=template&id=3c490c41&scoped=true"
import script from "./RoomBasement.vue?vue&type=script&lang=ts"
export * from "./RoomBasement.vue?vue&type=script&lang=ts"
import style0 from "./RoomBasement.vue?vue&type=style&index=0&id=3c490c41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c490c41",
  null
  
)

export default component.exports